import React from 'react';
import styled from 'styled-components';
import { Chip } from '@mui/material';
import SearchBar from './SearchBar';
import { getCategoryIcon, getAllCategoryIcon } from './CategoryIcons';
import { colors, spacing, typography } from '../styles/theme';

const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  background: ${colors.backgroundSecondary};
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid ${colors.borderLight};
  z-index: 50;
  padding: ${spacing.md} ${spacing.lg};
  padding-bottom: ${spacing.md};
`;

const Title = styled.h1`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.xxl};
  font-weight: ${typography.fontWeight.bold};
  color: ${colors.textPrimary};
  margin: 0 0 ${spacing.md} 0;
`;


const CategoriesContainer = styled.div`
  display: flex;
  gap: ${spacing.sm};
  overflow-x: auto;
  padding-bottom: ${spacing.xs};
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`;


interface HeaderProps {
  title: string;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  onFilterClick: () => void;
  categories: { id: string; name: string; icon: string }[];
}

const Header: React.FC<HeaderProps> = ({
  title,
  searchQuery,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  onFilterClick,
  categories
}) => {
  return (
    <HeaderContainer>
      <Title>{title}</Title>

      <SearchBar
        value={searchQuery}
        onChange={onSearchChange}
        onFilterClick={onFilterClick}
      />

      <CategoriesContainer>
        <Chip
          icon={getAllCategoryIcon()}
          label="Все"
          variant={selectedCategory === 'all' ? 'filled' : 'outlined'}
          color={selectedCategory === 'all' ? 'primary' : 'default'}
          onClick={() => onCategoryChange('all')}
          sx={{
            borderRadius: '20px',
            fontFamily: typography.fontFamily.primary,
            fontWeight: typography.fontWeight.medium,
            '& .MuiChip-icon': {
              color: selectedCategory === 'all' ? 'white' : colors.primary
            }
          }}
        />
        {categories.map((category) => (
          <Chip
            key={category.id}
            icon={getCategoryIcon(category.id)}
            label={category.name}
            variant={selectedCategory === category.id ? 'filled' : 'outlined'}
            color={selectedCategory === category.id ? 'primary' : 'default'}
            onClick={() => onCategoryChange(category.id)}
            sx={{
              borderRadius: '20px',
              fontFamily: typography.fontFamily.primary,
              fontWeight: typography.fontWeight.medium,
              '& .MuiChip-icon': {
                color: selectedCategory === category.id ? 'white' : colors.primary
              }
            }}
          />
        ))}
      </CategoriesContainer>
    </HeaderContainer>
  );
};

export default Header;
